const PAID = 'paid'
const UNPAYABLE = 'unpayable'
const UNPAID = 'unpaid'

export {
  PAID,
  UNPAYABLE,
  UNPAID
}